var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h2", [_vm._v(_vm._s(_setup.props.status.name))]),
      _vm._v(" "),
      _c("div", [
        _vm._v("Начислено вознаграждение - "),
        _c("b", [_vm._v(_vm._s(_setup.props.reward.sum) + "р")]),
      ]),
      _vm._v(" "),
      _setup.props.status.detail
        ? _c("div", {
            domProps: { innerHTML: _vm._s(_setup.props.status.detail) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.ButMes, {
        attrs: { ob: _setup.finob, text: "Подтвердить" },
        on: { input: _setup.start },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }